(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gtranslate"] && !Shopify.designMode) return;
  try {
    const syncLanguageLink = (owner, link) => {
    const url = new URL(location.href);
    url.hostname = `${link.dataset.languageCode === 'it' ? '' : `${link.dataset.languageCode}.`}antichitagalliera.com`;
    url.pathname = owner.dataset.languageSourcePath;
    link.href = url.href;
  };
  document.querySelectorAll('[data-language-selector]').forEach((owner) => {
    owner.querySelectorAll('[data-language-code]').forEach((link) => syncLanguageLink(owner, link));
  });
  document.addEventListener('click', (event) => {
    const owner = event.target.closest('[data-language-selector]');
    if (!owner) return;
    const dialog = owner.querySelector('dialog');
    if (event.target.closest('[data-language-open]')) dialog.showModal();
    if (event.target.closest('[data-language-close]')) dialog.close();
    const link = event.target.closest('[data-language-code]');
    if (link) {
      syncLanguageLink(owner, link);
    }
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["similar-jewel-request"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.SimilarRequest__Toggle');
  if (!toggle || typeof HTMLDialogElement === 'undefined') return;
  event.preventDefault();
  const details = toggle.closest('.SimilarRequest');
  let dialog = details._requestDialog;
  if (!dialog) {
    const panel = details.querySelector('[data-similar-preview]');
    dialog = document.createElement('dialog');
    dialog.className = 'SimilarRequest__Dialog';
    dialog.setAttribute('aria-labelledby', panel.querySelector('h3').id);
    const bar = document.createElement('div');
    bar.className = 'SimilarRequest__DialogBar';
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'SimilarRequest__Close';
    close.textContent = panel.dataset.closeLabel + ' ×';
    close.addEventListener('click', () => dialog.close());
    bar.append(close);
    dialog.append(bar, panel);
    document.body.append(dialog);
    details._requestDialog = dialog;
    dialog.addEventListener('close', () => { toggle.focus({ preventScroll: true }); });
  }
  dialog.showModal();
});

document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-request-channel]')) return;
  const input = event.target.closest('[data-similar-preview]').querySelector('[data-request-contact]');
  input.type = event.target.value === 'email' ? 'email' : 'tel';
  input.value = '';
  input.pattern = event.target.value === 'whatsapp' ? '[+]?[0-9 ()-]{7,25}' : '.*';
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-navigation"] && !Shopify.designMode) return;
  try {
    const shortcuts = document.querySelector('[data-size-guide-nav]');
  if (shortcuts) {
    const content = shortcuts.parentElement;
    const headings = [...content.querySelectorAll('h2')];
    const methods = headings.filter((heading) => /^\s*[12]\./.test(heading.textContent));
    const tableHeading = headings.find((heading) => /tabella/i.test(heading.textContent));
    if (methods.length === 2 && tableHeading && content.querySelector('table')) {
      [...methods,tableHeading].forEach((heading,index) => {
        heading.id = ['SizeGuideRing','SizeGuideFinger','SizeGuideTable'][index];
        heading.tabIndex = -1;
      });
      shortcuts.hidden = false;
      const table = content.querySelector('table');
      const toggle = content.querySelector('[data-size-guide-conversions]');
      const units = content.querySelector('[data-size-guide-units]');
      const header = table.querySelectorAll('thead tr')[1];
      if (header?.cells.length === 7 && header.cells[0].textContent.trim() === 'ITA' && /Diametro/i.test(header.cells[5].textContent) && /cm/.test(table.querySelector('thead').textContent)) {
        table.classList.add('SizeGuideTable', 'SizeGuideTable--simple');
        const target = table.closest('.TableWrapper') || table;
        target.before(toggle, units);
        toggle.hidden = false; units.hidden = false;
        toggle.addEventListener('click', () => {
          const currentTable = content.querySelector('table.SizeGuideTable');
          if (!currentTable) return;
          const simple = currentTable.classList.toggle('SizeGuideTable--simple');
          toggle.setAttribute('aria-pressed', String(!simple));
          toggle.textContent = simple ? toggle.dataset.show : toggle.dataset.hide;
        });
      }
      shortcuts.addEventListener('click', (event) => {
        const link = event.target.closest('a');
        if (link) content.querySelector(link.getAttribute('href'))?.focus({ preventScroll: true });
      });
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["theme-accessibility"] && !Shopify.designMode) return;
  try {
    const labelGallery = (scope = document) => {
    scope.querySelectorAll('.Product__SlideshowNavDot,.Product__SlideshowNavImage,.Product__SlideshowMobileNav .dot').forEach((dot) => {
      const sync = () => dot.setAttribute('aria-current', String(dot.classList.contains('is-selected')));
      sync();
      new MutationObserver(sync).observe(dot, { attributes: true, attributeFilter: ['class'] });
    });
  };
  labelGallery();
  document.addEventListener('shopify:section:load', (event) => labelGallery(event.target));
  } catch(e) { console.error(e); }
})();

})();
